import { TradePair } from '../../../context/chart/chartTypes';
import { formatUSD } from '../../../helpers';
import useTokenStats from '../../../hooks/web3/useTokenStats';

type MarkPriceProps = {
    pool: TradePair | undefined;
};

const MarkPrice: React.FC<MarkPriceProps> = ({ pool }) => {
    const tokenStats = useTokenStats();

    const markPrice =
        tokenStats && pool?.chartSymbol ? tokenStats?.[pool.chartSymbol]?.price ?? 0 : 0;

    return (
        <>
            {formatUSD(markPrice || 0, {
                minDecimals: 2,
                maxDecimals: pool?.decimalFormatting,
            })}
        </>
    );
};

export default MarkPrice;
